/** Assign-to-team value for QA / Tester in department team pickers. */
export const QA_TEAM_VALUE = 'QA';

/** Default assignee when routing work to the QA / Tester team (org QA lead). */
export const QA_TEAM_DEFAULT_ASSIGNEE_ID = 5;

export function isQaTesterTeam(teamValue) {
  const raw = String(teamValue || '').trim();
  if (!raw || raw === 'Any') return false;
  const key = raw.toLowerCase().replace(/[_-]+/g, ' ').replace(/\s+/g, ' ').trim();
  return key === 'qa' || key === 'qa tester';
}

export function pickQaTeamAssigneeId(assignableUsers = []) {
  const preferred = String(QA_TEAM_DEFAULT_ASSIGNEE_ID);
  if (assignableUsers.some((u) => String(u.id) === preferred)) return preferred;
  const first = assignableUsers[0];
  return first ? String(first.id) : '';
}
